// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"540":"35eb01017960d600","888":"6d16107b7a89202c"}[chunkId] + ".css";
};